module.exports = {"611021001":"城关街道","611021002":"四皓街道","611021101":"景村镇","611021102":"古城镇","611021103":"三要镇","611021104":"灵口镇","611021106":"寺耳镇","611021107":"巡检镇","611021108":"石坡镇","611021109":"石门镇","611021110":"麻坪镇","611021111":"洛源镇","611021112":"保安镇","611021114":"永丰镇","611021117":"柏峪寺镇","611021118":"高耀镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611021.json
// module id = 2884
// module chunks = 0